import { escape } from "./util/Html.ts";

export function TEMPLATE(main :any, ...dyn : any){
  //console.log(arguments)
  var result = [];
  for(var i=0;i<main.length;i++){
    result.push(main[i])
    if(i<dyn.length){
      if(dyn[i]===undefined){
      }else if(dyn[i]===null){
        result.push(null)
      }else if(typeof dyn[i] === 'function'){
        result.push(dyn[i]())
      }else if(Array.isArray(dyn[i])){
        //TODO apply all this test recursively to the content of the array and the result of function
        result.push(dyn[i].join(''))
      }else if(dyn[i].toHTML){
        result.push(dyn[i].toHTML())
      }else{
        result.push(escape(dyn[i].toString()))
      }
    }
  }
  return {toHTML : ()=>result.join(''),toString :()=>result.join('')}
}